export const CONN = {
  DISCONNECTED: 0,
  CONNECTED: 1,
  CONNECTING: 2,
};